import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";

import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";



const Lo2Commit = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo2-headings">
                <h1>Commits and Branches</h1>
                <p>I need to show and demonstrate that my work is tracked properly and organized</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                        <BreadcrumbHeader />
            </div>
            <div className="content-lo2">
                <div className="content-lo2-commit">
                    <div className="content-lo2-commit-text">
                    {/* <img src={gif2}></img> */}
                        <h1>TEST</h1>
                        <p>
                            
                        </p>
                        
                        
                    </div>

                    <div className="content-lo2-commit-text2">
                        <h1>Shared Google Drive</h1>
                        <p>
                            For our project, my groupmates and I decided to use google drive to store our group files. We do this to ensure
                            that the files are available for everyone to check, edit, or send it easily.
                        </p>
                    </div>

                    <div className="content-lo2-commit-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo2Commit;